<template>
  <div>
    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
          <h1>
            Metricas (Coberturas por servicio)
          </h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->
    <!-- @click.native="showDetails(service)" -->
    <el-row>
      <el-col :span="20" :offset="2">
        <el-card
          v-for="service in services"
          :key="service.service.uuid + service.disabled"
          class="service-card"
        >
          <div style="width:100%;text-align: center;">
            <img
              :src="getImgUrl(service.service.carrierName)"
              class="item-carrier-image"
            />
          </div>
          <p>Carrier: {{ service.service.carrierName }}</p>
          <p>Servicio: {{ service.service.serviceType }}</p>
          <p>País: {{ service.service.countryCode }}</p>
          <p>Coberturas: {{ service.count }}</p>
          <p>Deshabilitado: {{ service.disabled || "Ninguno" }}</p>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="dialogVisible"
      title="Service Details"
      width="40%"
    >
      <div v-if="selectedService">
        <p><strong>Service Name:</strong> {{ selectedService.service.name }}</p>
        <p>
          <strong>Country Code:</strong>
          {{ selectedService.service.countryCode }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { CSApi } from "@/libraries/api";

export default {
  data() {
    return {
      services: [],
      dialogVisible: false,
      selectedService: null,
    };
  },
  methods: {
    showDetails(service) {
      this.selectedService = service;
      this.dialogVisible = true;
    },
    getImgUrl(carrierName) {
      return `https://app.skydropx.com/img/carriers/${carrierName}.svg`;
    },
  },
  async mounted() {
    const response = await CSApi().get(`coverage/metrics`);

    const { data } = response.data;

    this.services = data;
  },
};
</script>

<style scoped>
.service-card {
  width: 30%;
  margin: 10px;
  display: inline-block;
  /* cursor: pointer; */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.item-carrier-image {
  height: 40px;
  object-fit: cover;
  display: inline-block;
}
</style>
